'use strict';

var _objectWithoutProperties = require("/usr/src/app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["styles"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CloseIcon = function CloseIcon(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "36"
  }, props), /*#__PURE__*/React__default['default'].createElement("g", {
    "data-name": "Component 5 \u2013 1",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    "data-name": "Ellipse 87",
    cx: "17.5",
    cy: "17.5",
    r: "17.5",
    transform: "rotate(90 17.5 17.5)",
    fill: "none",
    stroke: "#cdd1e2"
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    "data-name": "Group 854",
    transform: "rotate(90 545 222)",
    fill: "#0c0d17"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    "data-name": "Ellipse 93",
    cx: "1.5",
    cy: "1.5",
    r: "1.5",
    transform: "translate(333 748)"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    "data-name": "Ellipse 94",
    cx: "1.5",
    cy: "1.5",
    r: "1.5",
    transform: "translate(339 748)"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    "data-name": "Ellipse 95",
    cx: "1.5",
    cy: "1.5",
    r: "1.5",
    transform: "translate(345 748)"
  }))));
};

exports['default'] = CloseIcon;